export { default as CDPAssociatedashboard } from './associate-dashboard';
export { default as CdpDetails } from './details';
export { default as CdpUploadData } from './upload-data';

export { default as CDPAdminDashboard } from './admin-dashboard';
export { default as CdpDashboard } from './dashboard';
